import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { TextareaInput } from '../../Form/TextareaInput';

var Input = function Input(_ref) {
  var disabled = _ref.disabled,
      errors = _ref.errors,
      label = _ref.label,
      name = _ref.name,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      placeholder = _ref.placeholder,
      readonly = _ref.readonly,
      values = _ref.values,
      props = _objectWithoutProperties(_ref, ["disabled", "errors", "label", "name", "handleChange", "handleBlur", "placeholder", "readonly", "values"]);

  return /*#__PURE__*/React.createElement(TextareaInput, _extends({}, props, {
    disabled: disabled,
    error: errors[name],
    errorText: errors[name],
    id: name,
    label: label,
    name: name,
    onChange: handleChange,
    onBlur: handleBlur,
    placeholder: placeholder,
    readonly: readonly,
    value: values[name]
  }));
};

export { Input };